import API from "../config/api.js";

export const ReportService = {

    // getRoleInfo(name) {
    //   return API.get(`api/role/info/${name}`);
    // },

    getUserAvailability(data) {
      return API.post(`api/employer/userAvailability`,data);
    },

    getCompletedProjectReport(search, page=1) {
      return API.get(`api/projects/report/se=${search}?page=${page}`);
    },

    getProjectReport(search, page=1) {
      return API.get(`api/projects/report1/se=${search}?page=${page}`);
    },

  
};